var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sharing-embed'),_c('v-divider',{staticClass:"basic500 my-5"}),_c('sharing-qr-code'),_c('v-divider',{staticClass:"basic500 my-5"}),_c('sharing-seo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }